import React from 'react';
import { useWindowSize } from "../../hooks/useWindowSize";
import { IconButton } from "../IconButton";
import { HeaderContainer, Content, Title } from "./Header.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A simple header component
 *
 * @param title Title of the header
 * @param wrapperWidth Width of the wrapper
 * @param onReturn Function to be called when the return button is clicked
 */
const Header = props => {
  const {
    title,
    wrapperWidth,
    onReturn
  } = props;
  const windowSize = useWindowSize();
  const hasReturnButton = !!onReturn;
  return /*#__PURE__*/_jsx(HeaderContainer, {
    wrapperWidth: wrapperWidth,
    screenWidth: windowSize.width ?? 600,
    hasReturnButton: hasReturnButton,
    children: /*#__PURE__*/_jsxs(Content, {
      wrapperWidth: wrapperWidth,
      screenWidth: windowSize.width ?? 600,
      hasReturnButton: hasReturnButton,
      children: [onReturn && /*#__PURE__*/_jsx(IconButton, {
        icon: "ChevronLeft",
        color: "ghost",
        radius: "square",
        size: (windowSize.width ?? 600) < wrapperWidth + 152 ? 'sm' : 'lg',
        onClick: onReturn
      }), /*#__PURE__*/_jsx(Title, {
        wrapperWidth: wrapperWidth,
        screenWidth: windowSize.width ?? 600,
        hasReturnButton: hasReturnButton,
        children: title
      })]
    })
  });
};
export { Header };